import { FormEvent, PropsWithChildren } from 'react'

interface IProps {
  onSubmit: (ev: FormEvent) => void
  className?: string
}

const Form = (props: PropsWithChildren<IProps>) => {
  const handleSubmit = (ev: FormEvent) => {
    ev.preventDefault()
    props.onSubmit(ev)
  }

  return (
    <form onSubmit={handleSubmit} className={props.className}>
      {props.children}
    </form>
  )
}

export default Form
